// @flow

import { useDispatch } from 'react-redux';

import {
  getCart,
  setCartOwnerIsReseller,
  setCartProductOwner,
  setCartReselleeId,
  selectCartOwner,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import {
  updateCartProductOwner,
  updateProductsPayload,
} from 'src/Cart/AccountChoice/modules/actions';
import { resellableCartConfKeys } from 'src/Cart/AccountChoice/modules/helpers';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { bulkConfiguration } from 'src/modules/configurations';

type Props = {
  onSuccess: () => void,
};

export function useApplyCustomerProductOwner({ onSuccess }: Props): any {
  const dispatch = useDispatch();
  const translator = useTranslator();

  const cartOwnerId = useAppSelector(selectCartOwner);

  return async (newCustomerOwnerId: string) => {
    if (!newCustomerOwnerId) return;
    try {
      // prepare the reset correctly the cart product owner
      dispatch(setCartProductOwner(null));
      dispatch(setCartOwnerIsReseller(null));
      // apply the new product owner
      await dispatch(updateCartProductOwner());

      // declare the new resellee for updateProductsPayload
      dispatch(setCartReselleeId(newCustomerOwnerId));

      // prepare params for bulk conf
      const bulkParams = resellableCartConfKeys.map(productKey => ({
        ...productKey,
        payload: {
          resellee_id: newCustomerOwnerId,
          reseller_id: cartOwnerId,
        },
      }));

      await Promise.all([
        dispatch(updateProductsPayload({ translator })),
        dispatch(bulkConfiguration(bulkParams)),
      ]);

      await dispatch(getCart());

      onSuccess();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      // pass
      /// TODO: we should give a userfeedback about the error
    }
  };
}
